import React, { FC } from "react";

import { brand } from "../../theme/brands";

const Footer: FC = () => {
  return (
    <footer className="mt-auto bg-neutral-900 text-neutral-300 text-sm">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <div>
          Use our booking engine to host your event. Contact us on{" "}
          <a className="text-white underline" href={`mailto:${brand.contactEmail}`}>
            {brand.contactEmail}
          </a>{" "}
          for more information.
        </div>
        <div className="text-neutral-500">
          © {new Date().getFullYear()} {brand.name}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
